export default __webpack_public_path__ + "gemini.png";